import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs';
import {Link} from '@homeaway/react-localization-components';

import useEdapEvent from '../../../hooks/useEdapEvent';
import {DEFAULT_TRANSLATIONS} from '../../../utils/constants';

import './ViewMoreButton.less';

function ButtonLabel({buttonText, showChevron}) {
    return showChevron ? (
        <React.Fragment>
            <span>{buttonText}</span>{' '}
            <SVGIcon
                inlineFlex
                markup={CHEVRON_RIGHT__12}
                className="view-more-button__icon"
            />
        </React.Fragment>
    ) : (
        buttonText
    );
}

function ViewMoreButton({
    usePrimaryButton,
    searchUrl,
    fireSeeMoreEvent,
    buttonText,
    showChevron,
}) {
    const {seeMoreButtonClickEvent} = useEdapEvent();
    const ButtonComponent = usePrimaryButton ? ButtonPrimary : Button;

    return (
        !!searchUrl && (
            <Link href={searchUrl}>
                {(localizedUrl) => (
                    <ButtonComponent
                        label={
                            <ButtonLabel
                                buttonText={buttonText}
                                showChevron={showChevron}
                            />
                        }
                        onClick={() =>
                            seeMoreButtonClickEvent(fireSeeMoreEvent)
                        }
                        size="sm"
                        href={localizedUrl}
                    />
                )}
            </Link>
        )
    );
}

export const SeeMoreButton = ({
    isMobile,
    translations,
    fireSeeMoreEvent,
    searchUrl,
}) => {
    const classNames = cx({
        'recommended-carousel__button': true,
        'recommended-carousel__button--center': isMobile,
        'recommended-carousel__button--right': !isMobile,
    });

    return (
        <div className={classNames}>
            <ViewMoreButton
                buttonText={translations.seeMore}
                isMobile={isMobile}
                fireSeeMoreEvent={fireSeeMoreEvent}
                searchUrl={searchUrl}
            />
        </div>
    );
};

ViewMoreButton.propTypes = {
    buttonText: PropTypes.string,
    searchUrl: PropTypes.string.isRequired,
    showChevron: PropTypes.bool,
    usePrimaryButton: PropTypes.bool,
    fireSeeMoreEvent: PropTypes.bool,
};

ViewMoreButton.defaultProps = {
    buttonText: DEFAULT_TRANSLATIONS.seeMore,
    showChevron: false,
    usePrimaryButton: false,
    fireSeeMoreEvent: false,
};

export default ViewMoreButton;
